import React, { useMemo } from "react";

import { Select } from "components/Select";
import { SORT_DIRECTION } from "hooks/useSort";
import textStyles from "theme/textStyles";
// import { Box } from "@chakra-ui/react";

const SEPARATOR = "-";

export type SortSelectProps = {
  sortOptions?: SortOption<Record<string, any>>[];
  selectedSortKey?: string;
  selectedDirection?: SORT_DIRECTION;
  onChange?(sortKey: string | undefined, direction: SORT_DIRECTION): void;
};

const SortTermsSelect = ({
  sortOptions = [],
  selectedSortKey,
  selectedDirection,
  onChange: _onChange,
}: SortSelectProps): React.ReactElement => {
  const selectedSortOption = useMemo(() => {
    const sortOption = sortOptions.find(
      (option) => option.sortKey === selectedSortKey
    );
    return sortOption
      ? {
          value: `${selectedSortKey}${SEPARATOR}${selectedDirection}`,
          label: `${sortOption.label} ${
            selectedDirection === SORT_DIRECTION.ASC ? "Asc" : "Desc"
          }`,
        }
      : undefined;
  }, [selectedDirection, selectedSortKey, sortOptions]);
  const onChange = React.useCallback(
    (option: SelectOption) => {
      const [key, direction] = option?.value.split(SEPARATOR) ?? [];
      _onChange?.(!!key ? key : undefined, direction as SORT_DIRECTION);
    },
    [_onChange]
  );

  const options: SelectOption[] = useMemo(
    () =>
      sortOptions
        .map(({ sortKey, label }) => [
          {
            value: `${sortKey}${SEPARATOR}${SORT_DIRECTION.ASC}`,
            label: `${label} Asc`,
          },
          {
            value: `${sortKey}${SEPARATOR}${SORT_DIRECTION.DESC}`,
            label: `${label} Desc`,
          },
        ])
        .flat(),
    [sortOptions]
  );

  return (
    <Select
      value={selectedSortOption}
      onChange={onChange as any}
      options={options}
      isSearchable={false}
      isClearable={false}
      controlShouldRenderValue={false}
      placeholder="Sort"
      size="md"
      selectChakraStyleOverrides={{
        control: (provided) => ({
          ...provided,
          ...textStyles.label2,
          borderRadius: "12px",
        }),
      }}
      menuPosition="absolute"
    />
  );
};
export default SortTermsSelect;
